import gsap from 'gsap'

import { Animation } from '@/types'

export const headerRevealAnimation = ({
  node,
  context,
  conditions
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  /**
   * references
   */
  const place = selector('[data-motion-place]')
  const menuButton = selector('[data-motion-menu-button]')

  /**
   * reveal animation
   */
  const timeline = gsap
    .timeline({ defaults: { duration: 2, ease: 'power3.inOut' } })
    .fromTo(
      [place, menuButton],
      { yPercent: -100 },
      { yPercent: 0, stagger: { amount: 0 } }
    )

  /**
   * revert
   */
  return () => {
    timeline?.kill()
  }
}
